export default __webpack_public_path__ + "static/media/calendar-active.e09d186b.svg";